module.exports = __webpack_public_path__ + "media/images/made-with-rails-e242ccfa3f8d5ef94f9684a077c70517.svg";